import React, { useState, useEffect, useRef } from "react";

const About = (props) => {
  const sectionRef = useRef(null);
  const aboutData = props.dataAbout;
  const baseUrl = props.url;
  const homeUrl=props.homeurl || "";

  //console.log("ok"+aboutData.title);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const sectionTop = sectionRef.current.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;

        // Add 'animate' class if the section is within the viewport range
        if (
          sectionTop < viewportHeight - 100 &&
          !sectionRef.current.classList.contains("animate")
        ) {
          sectionRef.current.classList.add("animate");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Run once when the component mounts

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="about-section" ref={sectionRef}>
      <div className="container">
        <h2 className="universal-header">{aboutData.title}</h2>
        <div className="about-container">
          <div className="about-image">
            <img 
              src={baseUrl+aboutData.image} 
              alt="who-we-are-img" 
              style={{
                      width: "100%",
                      height: "100%",
                    }}
            />
          </div>
          <div className="about-content">
            <div dangerouslySetInnerHTML={{ __html: aboutData.description }} />
            {aboutData.button_name!==null ? 
              <div className="about-button">
                <a className="viewmore-btn" href={homeUrl+aboutData.button_link}>
                  {aboutData.button_name}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <rect width="42" height="42" fill="none" />
                    <path
                      d="M16 32L32 16M32 16H20M32 16V28"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </div>
              : null
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
